import { Rhythm } from "@/components/report/Rhythm";
import Rhythm2 from "@/components/report/Rhythm2";
import {
  ReportPageBaseProps,
  Rhythm2Response,
  RhythmResponse,
} from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { usePageUserType } from "@/utils/router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function RhythmPage({ setIndicator }: ReportPageBaseProps) {
  const { uuid } = useParams();
  const userType = usePageUserType();
  const axios = useAxios();
  const [data, setData] = useState<{ publish_version: string } | null>(null);
  useEffect(() => {
    (async () => {
      const response = await axios.get(`/api/report/${uuid}/rhythm`);
      setData(response.data);
      setIndicator(false);
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null || data == null) return <></>;
  switch (data.publish_version) {
    case "1.0":
    case "1.1":
      // PDF版
      return <></>;
    case "2.0":
    case "3.0":
    case "3.1":
      // 旧Webレポート
      return (
        <Rhythm data={data as RhythmResponse} userType={userType} uuid={uuid} />
      );
    case "4.0":
    default:
      // Webレポート改善版
      return (
        <Rhythm2
          data={data as Rhythm2Response}
          userType={userType}
          uuid={uuid}
        />
      );
  }
}
